import {
    FETCH_DATA_OPTIONS_REQUEST,
    FETCH_DATA_OPTIONS_SUCCESS,
    FETCH_DATA_OPTIONS_FAILURE,
    SAVE_DATA_OPTIONS_REQUEST,
    SAVE_DATA_OPTIONS_SUCCESS
} from "./constants";
  
import { IRegisterOption } from "./../../../models";

export const fetchOptionsRequest = (payload: IRegisterOption) => ({
    type: FETCH_DATA_OPTIONS_REQUEST,
    payload
  });
  
  export const fetchOptionsSuccess = (payload: IRegisterOption) => ({
    type: FETCH_DATA_OPTIONS_SUCCESS,
    payload
  });
  
  export const fetchOptionsFailure = (error: string) => ({
    type: FETCH_DATA_OPTIONS_FAILURE,
    payload: { error }
  });
  
  export const saveDataOptionsRequest = (payload: IRegisterOption) => ({
    type: SAVE_DATA_OPTIONS_REQUEST,
    payload
  });
  
  export const saveDataOptionsSuccess = (payload: IRegisterOption) => ({
    type: SAVE_DATA_OPTIONS_SUCCESS,
    payload
  });
  
